import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import serviceInitialStateGenerator from '@pages/AdditionalServices/containers/services/serviceStateGenerator';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * TemplateStoreProcessor фомирует восстановленое состояние стора доп. услуг.
 */
export class TemplateStoreProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    setUpServiceData: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const templateStore = serviceInitialStateGenerator().Restore(
      additionalServiceState.VariantServices,
      additionalServiceState.FieldsToDisplay,
      additionalServiceState.FieldValues,
      additionalServiceState.VariantFields,
      additionalServiceState.VariantFieldValues,
      setUpServiceData.TemporaryStore
    );

    return {
      isValid: true,
      additionalServiceState: {
        ...additionalServiceState,
        ServiceTemplateStore: templateStore,
      },
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
